﻿/**
 * Judge.me reviews → cards + carrossel mobile + garantir modal “escrever avaliação”.
 * Desktop: 8 avaliações por página (grid 4×2); mobile mantém o default do metafield.
 */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  var MQ_DESKTOP = window.matchMedia('(min-width: 750px)');
  var DESKTOP_PER_PAGE = 8;

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  /** CDN Judge.me: sobe width para thumbs nítidos em retina */
  function withMediaWidth(url, width) {
    if (!url || url.indexOf('data:') === 0) return url;
    if (/([?&]width=)\d+/i.test(url)) {
      return url.replace(/([?&]width=)\d+/i, '$1' + width);
    }
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  /** Galeria UGC: lazy → src nítido; sem sparse enlarge */
  function enhanceGallery(section) {
    var gallery = qs(section, '.jdgm-gallery');
    if (gallery) {
      gallery.classList.remove('tt-jdgm-gallery--sparse');
    }

    section.querySelectorAll('img.jdgm-gallery__thumbnail, img.jdgm-rev__pic-img').forEach(function (img) {
      var targetW = 144;
      var data = img.getAttribute('data-src');
      var src = img.getAttribute('src');
      var best = withMediaWidth(data || src, targetW);
      if (!best) return;

      if (data) img.setAttribute('data-src', withMediaWidth(data, targetW));
      if (!src || src.indexOf('data:') === 0 || src !== best) {
        img.setAttribute('src', best);
      }

      var wrap = img.closest('.jdgm--loading');
      if (wrap) wrap.classList.remove('jdgm--loading');
    });
  }

  /** Garante shell + form/modal Judge.me (v3 modal_write_review_flow) */
  function ensureWriteReview(section) {
    var widget = qs(section, '#judgeme_product_reviews.jdgm-review-widget, .jdgm-review-widget');
    if (!widget || !window.jdgm) return;

    // Mostra o CTA (Judge.me deixa display:none até setup completo)
    section.querySelectorAll('.jdgm-write-rev-link').forEach(function (a) {
      if (a.style.display === 'none' || !a.style.display) {
        a.style.display = 'inline-flex';
      }
    });

    enhanceGallery(section);

    try {
      if (typeof jdgm._renderAndSetupReviewForm === 'function' && window.jdgm.$) {
        jdgm._renderAndSetupReviewForm(jdgm.$(widget));
      }
      if (typeof jdgm.initializeWidgets === 'function') {
        jdgm.initializeWidgets();
      }
    } catch (e) {
      /* Judge.me ainda a carregar — re-tentamos nos timeouts */
    }
  }

  /** Sync atributo + cache jQuery (Judge.me lê .data('per-page') nos cliques) */
  function setPerPage(paginate, n) {
    if (!paginate) return;
    paginate.setAttribute('data-per-page', String(n));
    if (window.jdgm && jdgm.$) {
      try {
        jdgm.$(paginate).data('per-page', n);
      } catch (e) {
        /* ignore */
      }
    }
    if (window.jdgmSettings) {
      jdgmSettings.product_review_widget_per_page = n;
    }
  }

  /** Desfaz o wrap de cards para poder trocar o HTML das reviews */
  function unwrapCards(track) {
    if (!track) return track;
    var wrap = track.closest('.tt-jdgm-cards-wrap');
    if (!wrap) {
      delete track.dataset.ttCards;
      return track;
    }
    var nav = wrap.querySelector('.tt-jdgm-cards-nav');
    if (nav) nav.remove();
    wrap.parentNode.insertBefore(track, wrap);
    wrap.remove();
    delete track.dataset.ttCards;
    return track;
  }

  /** Aplica HTML da API Judge.me (reviews + paginação) */
  function applyReviewsHtml(section, html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var newTrack = tmp.querySelector('.jdgm-rev-widg__reviews');
    var newPag = tmp.querySelector('.jdgm-paginate');
    var track = qs(section, '.jdgm-rev-widg__reviews');
    var paginate = qs(section, '.jdgm-paginate');
    if (!track || !newTrack) return false;

    unwrapCards(track);
    track.innerHTML = newTrack.innerHTML;

    if (paginate && newPag) {
      paginate.innerHTML = newPag.innerHTML;
      setPerPage(paginate, DESKTOP_PER_PAGE);
      var emptyPag = !(newPag.textContent || '').trim();
      var hiddenPag = (newPag.getAttribute('style') || '').indexOf('display: none') >= 0;
      paginate.style.display = emptyPag || hiddenPag ? 'none' : '';
    }
    return true;
  }

  /** Recarrega página 1 com per_page=8 (metafield costuma vir com 5) */
  function reloadDesktopPage(section) {
    if (section.dataset.ttPerPageLoading === '1') return;

    var widget = qs(section, '#judgeme_product_reviews, .jdgm-review-widget');
    var paginate = qs(section, '.jdgm-paginate');
    var revWidg = qs(section, '.jdgm-rev-widg');
    if (!widget || !paginate || !revWidg) return;

    var productId = widget.getAttribute('data-id');
    var shop =
      (window.jdgm && typeof jdgm.shopDomain === 'function' && jdgm.shopDomain()) ||
      (window.jdgmSettings && jdgmSettings.shop_domain) ||
      '';
    if (!productId || !shop) return;

    var urlBase =
      paginate.getAttribute('data-url') ||
      'https://api.judge.me/reviews/reviews_for_widget?legacy_widget=true';
    var updated = revWidg.getAttribute('data-updated-at');
    var ts = updated ? Math.floor(Date.parse(updated) / 1000) : '';
    var params = new URLSearchParams({
      page: '1',
      per_page: String(DESKTOP_PER_PAGE),
      product_id: String(productId),
      shop_domain: shop,
      platform: 'shopify',
      url: shop,
    });
    if (ts) params.set('ts', String(ts));

    var sortBy = widget.getAttribute('data-sort-by');
    var sortDir = widget.getAttribute('data-sort-dir');
    if (sortBy) params.set('sort_by', sortBy);
    if (sortDir) params.set('sort_dir', sortDir);

    section.dataset.ttPerPageLoading = '1';
    var join = urlBase.indexOf('?') >= 0 ? '&' : '?';

    fetch(urlBase + join + params.toString(), { credentials: 'omit' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.html) return;
        applyReviewsHtml(section, data.html);
        setPerPage(qs(section, '.jdgm-paginate'), DESKTOP_PER_PAGE);
        section.dataset.ttPerPage = String(DESKTOP_PER_PAGE);
        enhanceGallery(section);
        setupCards(section);
      })
      .catch(function () {
        /* rede / CORS — mantém as 5 do metafield */
      })
      .finally(function () {
        section.dataset.ttPerPageLoading = '0';
      });
  }

  /** Desktop ≥750: 8 reviews/página (2 filas × 4 col) */
  function ensureDesktopPerPage(section) {
    var paginate = qs(section, '.jdgm-paginate');
    if (!paginate) return;

    if (!MQ_DESKTOP.matches) return;

    setPerPage(paginate, DESKTOP_PER_PAGE);
    if (section.dataset.ttPerPage === String(DESKTOP_PER_PAGE)) return;
    if (section.dataset.ttPerPageLoading === '1') return;

    var track = qs(section, '.jdgm-rev-widg__reviews');
    var revWidg = qs(section, '.jdgm-rev-widg');
    var shown = track ? track.querySelectorAll('.jdgm-rev').length : 0;
    var total = revWidg
      ? parseInt(revWidg.getAttribute('data-number-of-reviews') || '0', 10) || 0
      : 0;

    // Já cabe numa página (ou não há mais reviews para buscar)
    if (shown >= DESKTOP_PER_PAGE || shown >= total || total < 1) {
      section.dataset.ttPerPage = String(DESKTOP_PER_PAGE);
      return;
    }

    reloadDesktopPage(section);
  }

  function setupCards(section) {
    var track = qs(section, '.jdgm-rev-widg__reviews');
    if (!track || track.dataset.ttCards === '1') return;
    if (!track.querySelector('.jdgm-rev')) return;

    track.dataset.ttCards = '1';

    var wrap = document.createElement('div');
    wrap.className = 'tt-jdgm-cards-wrap';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    var nav = document.createElement('div');
    nav.className = 'tt-jdgm-cards-nav';
    nav.setAttribute('aria-label', 'Navegar avaliações');
    nav.innerHTML =
      '<button type="button" class="tt-jdgm-cards-nav__btn tt-jdgm-cards-nav__btn--prev" aria-label="Anterior">‹</button>' +
      '<div class="tt-jdgm-cards-dots" role="tablist" aria-label="Páginas de avaliações"></div>' +
      '<button type="button" class="tt-jdgm-cards-nav__btn tt-jdgm-cards-nav__btn--next" aria-label="Próxima">›</button>';
    wrap.appendChild(nav);

    var prev = qs(nav, '.tt-jdgm-cards-nav__btn--prev');
    var next = qs(nav, '.tt-jdgm-cards-nav__btn--next');
    var dotsEl = qs(nav, '.tt-jdgm-cards-dots');

    function cards() {
      return Array.prototype.slice.call(track.querySelectorAll('.jdgm-rev'));
    }

    function buildDots() {
      dotsEl.innerHTML = '';
      cards().forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tt-jdgm-cards-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Avaliação ' + (i + 1));
        b.addEventListener('click', function () {
          var el = cards()[i];
          if (el) el.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsEl.appendChild(b);
      });
    }

    function activeIndex() {
      var list = cards();
      if (!list.length) return 0;
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      list.forEach(function (el, i) {
        var dist = Math.abs(el.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }

    function sync() {
      var list = cards();
      var i = activeIndex();
      dotsEl.querySelectorAll('.tt-jdgm-cards-dot').forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
      });
      prev.disabled = i <= 0;
      next.disabled = i >= list.length - 1;
      nav.hidden = !MQ.matches || list.length < 2;
    }

    function scrollByCard(dir) {
      var list = cards();
      var i = Math.min(list.length - 1, Math.max(0, activeIndex() + dir));
      if (list[i]) list[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    prev.addEventListener('click', function () {
      scrollByCard(-1);
    });
    next.addEventListener('click', function () {
      scrollByCard(1);
    });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    });
    MQ.addEventListener('change', sync);

    buildDots();
    sync();
  }

  function enhance(section) {
    ensureWriteReview(section);
    enhanceGallery(section);
    ensureDesktopPerPage(section);
    setupCards(section);
  }

  /** Badge sob o H1 / card: some se 0 reviews (sem reservar espaço) */
  function syncPreviewBadges() {
    document.querySelectorAll('.tt-jdgm-badge').forEach(function (wrap) {
      var badge = wrap.querySelector('.jdgm-prev-badge');
      var n = 0;
      if (badge) {
        n = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10) || 0;
      }
      var text = wrap.querySelector('.jdgm-prev-badge__text');
      var label = text ? (text.textContent || '').trim() : '';
      var emptyLabel = /^(no reviews|sem avalia|0 avalia|be the first)/i.test(label);
      var empty = !badge || n < 1 || emptyLabel;

      wrap.classList.toggle('is-empty', empty);
      if (empty) {
        wrap.setAttribute('hidden', '');
      } else {
        wrap.removeAttribute('hidden');
        // Judge.me às vezes deixa display:none no temp-hide
        if (badge && badge.style.display === 'none') {
          badge.style.display = '';
        }
      }
    });
  }

  function run() {
    syncPreviewBadges();
    document.querySelectorAll('.tt-jdgm').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  [400, 1200, 2500, 4000].forEach(function (ms) {
    setTimeout(run, ms);
  });

  // Se o utilizador alarga para desktop, sobe para 8/página
  MQ_DESKTOP.addEventListener('change', function () {
    if (MQ_DESKTOP.matches) {
      document.querySelectorAll('.tt-jdgm').forEach(function (section) {
        delete section.dataset.ttPerPage;
        enhance(section);
      });
    }
  });
})();
